import { call, put, takeLatest } from 'redux-saga/effects'
import * as fromActions from '../../actions/chat.action'
import I18n from 'i18n'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'
import { getMessages, getConversationMessages } from 'api/chat/Get'
import deleteMessage from 'api/chat/Delete'

async function deleteChatMessage(messageId: number) {
  return await deleteMessage(messageId)
}

async function handleGetMessages({ courseId, conversationId, identifier = 0 }: any) {
  if (conversationId) return await getConversationMessages(conversationId, identifier)
  return await getMessages(courseId, identifier)
}

function* deleteMessageEffectSaga(action: any) {
  try {
    const {
      payload: { courseId, messageId, conversationId, identifier },
    } = action
    yield call(deleteChatMessage, messageId)
    const data = yield call(handleGetMessages, { courseId, conversationId, identifier })
    yield put(fromActions.Actions.getChatMessagesSuccess(data))
    SuccessToast(I18n.t('administration.toastMessages.deleteMessageSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.sendMessageError'))
    console.log('error: ', error)
  }
}

export function* deleteMessageWatcherSaga() {
  yield takeLatest(fromActions.DESTROY_CHAT_MESSAGE, deleteMessageEffectSaga)
}
